/*
 * Bundle set / perfect match pop-up.
 * Reads the shop money format from the element's data-money-format attribute so
 * this file stays static (no Liquid) and cacheable.
 */
(function () {
  if (window.customElements.get('bundle-set')) return;

  var MONEY_FORMAT = null;
  var MONEY_HAS_MARKUP = false;
  var moneyFormatter = null;
  var MONEY_PLACEHOLDER = /\{\{\s*\w+\s*\}\}/;

  function initMoney(fmt) {
    MONEY_FORMAT = fmt || '${{amount}}';
    // Most shops use a plain format; only then can we use the (much cheaper)
    // textContent path instead of invoking the HTML parser on every update.
    MONEY_HAS_MARKUP = MONEY_FORMAT.indexOf('<') !== -1;

    var decimals = /amount_no_decimals/.test(MONEY_FORMAT) ? 0 : 2;
    // Built once and reused: Number#toLocaleString spins up a fresh
    // Intl.NumberFormat on every call, and a single product switch used to
    // trigger half a dozen of them.
    moneyFormatter = new Intl.NumberFormat('es-MX', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function formatMoney(cents) {
    return MONEY_FORMAT.replace(MONEY_PLACEHOLDER, moneyFormatter.format(cents / 100));
  }

  function writeMoney(el, cents) {
    if (!el) return;
    var str = formatMoney(cents);
    if (MONEY_HAS_MARKUP) el.innerHTML = str;
    else el.textContent = str;
  }

  function truncateWords(str, n) {
    var words = (str || '').trim().split(/\s+/);
    return words.slice(0, n).join(' ');
  }

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  class BundleSet extends HTMLElement {
    connectedCallback() {
      if (MONEY_FORMAT === null) initMoney(this.dataset.moneyFormat);

      this.modal = this.querySelector('[data-smset-modal]');
      this.discountCode = this.dataset.discountCode || '';
      this.disc = parseInt(this.dataset.discount || '0', 10) || 0;
      this._lastFocus = null;
      this._warmed = false;
      this._onKey = this._onKey.bind(this);

      this._cacheRefs();
      this._initProducts();

      // A single delegated listener handles opening, closing, options and adding.
      this.addEventListener('click', this._onClick.bind(this));

      // Warm the pop-up images as soon as the shopper shows intent: they are
      // lazy and live inside a display:none container, so nothing is fetched
      // until then and the first switch would otherwise wait on the network.
      var card = this.querySelector('.smset-card') || this;
      var warm = this._warm.bind(this);
      card.addEventListener('pointerenter', warm, { once: true });
      card.addEventListener('focusin', warm, { once: true });

      this._syncCompanionLine();
      this._updateAddState();
    }

    // The pop-up structure never changes, so every node the interactions touch is
    // resolved once instead of on each click.
    _cacheRefs() {
      this._switchWrap = this.querySelector('[data-smset-switch]');
      this._switchItems = this._switchWrap
        ? toArray(this._switchWrap.querySelectorAll('[data-smset-switch-item]'))
        : [];

      this._activeIdx = 0;
      for (var i = 0; i < this._switchItems.length; i++) {
        if (this._switchItems[i].classList.contains('is-active')) { this._activeIdx = i; break; }
      }

      this._prods = toArray(this.querySelectorAll('.bsx-prod'));
      // Products outside the switchable slot always count toward the set.
      this._fixedProds = this._prods.filter(function (prod) {
        return !prod.closest('[data-smset-switch-item]');
      });
      this._itemProds = this._switchItems.map(function (item) {
        return item.querySelector('.bsx-prod');
      });

      this._els = {
        companionName: this.querySelector('[data-smset-companion-name]'),
        companionPrice: this.querySelector('[data-smset-companion-price]'),
        compare: this.querySelector('[data-smset-compare]'),
        total: this.querySelector('[data-smset-total]'),
        savings: this.querySelector('[data-smset-savings]'),
        add: this.querySelector('[data-smset-add]')
      };

      // Summary line per product, keyed by product id.
      this._lines = {};
      var self = this;
      this.querySelectorAll('[data-smset-line]').forEach(function (el) {
        self._lines[el.getAttribute('data-smset-line')] = el;
      });
    }

    // Products that count toward the set: the fixed lead plus the currently active
    // companion inside the switchable slot (inactive companions are skipped).
    _activeProducts() {
      var out = this._fixedProds.slice();
      var companion = this._itemProds[this._activeIdx];
      if (companion) out.push(companion);
      return out;
    }

    _initProducts() {
      this._prods.forEach(function (prod) {
        // Selected option value per option position (from the active buttons).
        var selected = {};
        prod.querySelectorAll('[data-smset-options]').forEach(function (group) {
          var pos = parseInt(group.dataset.optionPosition, 10);
          var active = group.querySelector('[data-value].active') || group.querySelector('[data-value]');
          if (active) { active.classList.add('active'); selected[pos] = active.dataset.value; }
        });
        prod._selected = selected;

        var nm = prod.querySelector('.bsx-nm');
        prod._shortName = nm ? truncateWords(nm.textContent, 3) : '';
      });
    }

    // The variant map is only needed once an option is clicked, so parsing is
    // deferred: doing it for every product on page load blocked the main thread
    // of the product page for nothing.
    _variantsOf(prod) {
      if (prod._variants) return prod._variants;
      var script = prod.querySelector('[data-smset-variants]');
      var variants = [];
      if (script) { try { variants = JSON.parse(script.textContent); } catch (e) {} }
      prod._variants = variants;
      return variants;
    }

    _warm() {
      if (this._warmed || !this.modal) return;
      this._warmed = true;
      // Flipping lazy -> eager restarts the load, even while the pop-up is
      // still hidden.
      this.modal.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.loading = 'eager';
      });
    }

    _onClick(e) {
      if (e.target.closest('[data-smset-prev]')) { this._switch(-1); return; }
      if (e.target.closest('[data-smset-next]')) { this._switch(1); return; }
      var opt = e.target.closest('[data-value]');
      if (opt && this.contains(opt)) { this._onOption(opt); return; }
      if (e.target.closest('[data-smset-open]')) { e.preventDefault(); this.open(); }
      else if (e.target.closest('[data-smset-close]')) { this.close(); }
      else if (e.target.closest('[data-smset-add]')) { this._addSet(e); }
    }

    // Cycle the active companion inside the switchable slot and refresh totals.
    _switch(dir) {
      var items = this._switchItems;
      if (items.length < 2) return;

      var idx = this._activeIdx;
      var next = (idx + dir + items.length) % items.length;
      if (next === idx) return;

      items[idx].classList.remove('is-active');
      items[next].classList.add('is-active');
      this._activeIdx = next;

      this._syncCompanionLine();
      this._recalc();
      this._updateAddState();
    }

    // Keep the single companion summary line in step with the active companion.
    _syncCompanionLine() {
      var active = this._itemProds[this._activeIdx];
      if (!active) return;
      if (this._els.companionName) this._els.companionName.textContent = active._shortName || '';
      writeMoney(this._els.companionPrice, parseInt(active.dataset.price || '0', 10));
    }

    open() {
      if (!this.modal) return;
      this._warm();
      this._lastFocus = document.activeElement;
      this.modal.classList.add('open');
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('smset-lock');
      document.addEventListener('keydown', this._onKey);
      var closeBtn = this.modal.querySelector('[data-smset-close]');
      if (closeBtn) closeBtn.focus();
    }

    close() {
      if (!this.modal) return;
      this.modal.classList.remove('open');
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('smset-lock');
      document.removeEventListener('keydown', this._onKey);
      if (this._lastFocus && typeof this._lastFocus.focus === 'function') this._lastFocus.focus();
    }

    _onKey(e) { if (e.key === 'Escape') this.close(); }

    _onOption(btn) {
      var group = btn.closest('[data-smset-options]');
      var prod = btn.closest('.bsx-prod');
      if (!group || !prod) return;
      if (btn.classList.contains('active')) return;

      var pos = parseInt(group.dataset.optionPosition, 10);
      group.querySelectorAll('[data-value]').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      prod._selected[pos] = btn.dataset.value;

      this._resolveVariant(prod);
    }

    _resolveVariant(prod) {
      var sel = prod._selected || {};
      var wanted = Object.keys(sel).map(Number).sort(function (a, b) { return a - b; })
        .map(function (pos) { return sel[pos]; });

      var match = this._variantsOf(prod).find(function (v) {
        return wanted.every(function (val, i) { return v.options[i] === val; });
      });
      if (!match) return;

      prod.dataset.variantId = match.id;
      prod.dataset.price = match.price;
      prod.dataset.available = match.available ? 'true' : 'false';

      if (match.image) this._swapImage(prod, match.image);

      var lineEl = this._lines[prod.dataset.productId];
      if (lineEl) writeMoney(lineEl, match.price);
      writeMoney(prod.querySelector('[data-smset-item-price]'), match.price);
      var label = prod.querySelector('[data-smset-meta-label]');
      if (label && wanted.length) label.textContent = wanted.join(' / ');

      this._syncCompanionLine();
      this._recalc();
      this._updateAddState();
    }

    // The variant map carries the 700px URL, which is up to four times the pixels
    // the card actually shows. Rewriting the CDN width down to the same steps the
    // srcset already uses keeps the swap light and usually hits a cached file.
    _rightSize(imgEl, src) {
      var width = (imgEl.clientWidth || 340) * Math.min(window.devicePixelRatio || 1, 2);
      var step = [250, 350, 500, 700].find(function (candidate) { return candidate >= width; }) || 700;
      return src.replace(/([?&]width=)\d+/, '$1' + step);
    }

    // Decode the new photo off-screen and only then swap it in, so the card does
    // not blank out while the variant image downloads. The token guards against
    // a slow response landing after a newer pick.
    _swapImage(prod, src) {
      var imgEl = prod.querySelector('.bsx-ph img');
      if (!imgEl) return;

      var url = this._rightSize(imgEl, src);
      if (imgEl.getAttribute('src') === url) return;

      var token = (prod._imgToken || 0) + 1;
      prod._imgToken = token;

      var apply = function () {
        if (prod._imgToken !== token) return;
        imgEl.removeAttribute('srcset');
        imgEl.removeAttribute('sizes');
        imgEl.src = url;
      };

      var pre = new Image();
      pre.src = url;
      if (pre.decode) pre.decode().then(apply, apply);
      else if (pre.complete) apply();
      else { pre.onload = apply; pre.onerror = apply; }
    }

    _updateAddState() {
      var addBtn = this._els.add;
      if (!addBtn) return;
      var unavailable = this._activeProducts().some(function (prod) {
        return prod.dataset.available === 'false';
      });
      addBtn.disabled = unavailable;
      addBtn.textContent = unavailable ? 'Selección no disponible' : (addBtn.dataset.label || addBtn.textContent);
    }

    _recalc() {
      var total = 0;
      this._activeProducts().forEach(function (prod) {
        total += parseInt(prod.dataset.price || '0', 10);
      });
      var discounted = this.disc > 0 ? Math.round(total - (total * this.disc / 100)) : total;

      writeMoney(this._els.compare, total);
      writeMoney(this._els.total, discounted);
      writeMoney(this._els.savings, total - discounted);
    }

    async _addSet(e) {
      var btn = e.target.closest('[data-smset-add]');
      if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;

      var items = [];
      this._activeProducts().forEach(function (prod) {
        var id = parseInt(prod.dataset.variantId, 10);
        if (id) items.push({ id: id, quantity: 1 });
      });
      if (!items.length) return;

      btn.setAttribute('aria-busy', 'true');
      try {
        var res = await fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        });
        if (!res.ok) throw new Error('add failed');

        this.close();

        // A configured discount code takes over the flow and lands on the cart.
        if (this.discountCode) {
          window.location.href = root().replace(/\/$/, '') + '/discount/' +
            encodeURIComponent(this.discountCode) + '?redirect=' + encodeURIComponent(root() + 'cart');
          return;
        }

        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') {
          // Refresh the drawer contents, then open it once the refresh settles.
          drawer.addEventListener('cart-drawer:refreshed', function onReady() {
            drawer.removeEventListener('cart-drawer:refreshed', onReady);
            try { drawer.show(); } catch (err) {}
          }, { once: true });
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          // Fallback in case the refresh event never fires.
          setTimeout(function () { try { drawer.show(); } catch (err) {} }, 400);
        } else {
          window.location.href = root() + 'cart';
        }
      } catch (err) {
        window.location.href = root() + 'cart';
      } finally {
        btn.removeAttribute('aria-busy');
      }
    }
  }

  window.customElements.define('bundle-set', BundleSet);
})();
